export default __webpack_public_path__ + "static/media/Camion2.2d130b6f.png";